module.exports = __webpack_public_path__ + "img/image_not_found.a1de53dd.jpg";